import {post} from '../script/serviceApiPost';

export default{
  async selectPageData(dataRow: any) {
    const result = await post('personAttr/selectPageData', dataRow);
    return result;
  },
  
  async deleteById(dataRow: any) {
    const result = await post('personVal/deleteById', dataRow);
    return result;
  },
  async deleteCurIp(dataRow: any) {
    const result = await post('commonCache/deleteCurIp', dataRow);
    return result;
  },

  //------------personVal下的
  async updateAnswer(dataRow: any) {
    const result = await post('personVal/updateAnswer', dataRow);
    return result;
  },
  async selectRealPerson(dataRow: any) {
    const result = await post('personVal/selectRealPerson', dataRow);
    return result;
  },
  
  
};
